import React, { memo, useCallback, useState } from 'react'
import api from '../../../../middleware/api';
import { useCapsuleConfigurator } from '../../../../context/CapsuleConfiguratorContext';
import { toast } from 'react-toastify';
import { useOutletContext } from 'react-router-dom';

const SensiblityCell = ({ value, row, table }) => {
  const options = [0, 1, 2, 3, 4, 5]
  const [loadingOption, setLoadingOption] = useState(null);

  const { setData: updateCustomerData } = useOutletContext()
  const { selectedConfigurationId, capsuleConfiguration, updateConfigurationIsValid, synchronizeConfigurations } = useCapsuleConfigurator()


  const handleChange = useCallback(async (option) => {
    const newValue = value === option ? null : option
    const index = capsuleConfiguration.content.findIndex(content => content.mixture.id === row.original.mixture.id)

    setLoadingOption(option);

    try {
      const response = await api.put(`/capsules/configurations/update/content`, {
        configurationId: selectedConfigurationId,
        property: 'sensibility',
        index: index,
        newValue: newValue
      })

      if (response.status === 200) {
        console.log(response.data)
        table.options.meta.updateColumnWithMixtureId(row.original.mixture.id, 'sensibility', newValue);
        updateConfigurationIsValid(response.data.configurations[0].isValid)
        synchronizeConfigurations(response.data.configurations)
        // Mise à jour optimisée pour éviter un re-render complet
      } else {
        toast.error('Erreur lors de la mise à jour de la sensibilité');
      }
    } catch (error) {
      toast.error('Erreur de connexion');
    } finally {
      setLoadingOption(null);
    }
  }, [value, row.original.mixture.id, capsuleConfiguration, selectedConfigurationId]);

  return (
    <div className="flex flex-row">
      {options.map((option) => (
        <button
          key={`row-${row.index}-${option}`}
          className={`btn btn-sm cursor-pointer ${value === option ? 'btn-primary' : 'btn-ghost'} hover:bg-primary/50 `}
          onClick={() => handleChange(option)}
          disabled={loadingOption !== null}
        >
          {loadingOption === option ? <span className="loading loading-spinner loading-xs"></span> : option}
        </button>
      ))}
    </div>
  )
}

// Utiliser memo pour éviter les re-renders inutiles
export default memo(SensiblityCell, (prevProps, nextProps) => {
  // Ne re-render que si la valeur a changé ou si la ligne a changé
  return prevProps.value === nextProps.value && prevProps.row.id === nextProps.row.id;
});
